import React, {FC} from 'react'
import {Link, Tooltip} from '@mdsol/onex-design'

import {CellPropsType} from './cellPropsType'

const RaveUrlCell: FC<CellPropsType> = ({cell}) => {
  const hostname = cell.getValue()
  const {original, index} = cell.row
  const {databaseId, raveUrl} = original

  return hostname.length
    ? <Tooltip
      id={`tooltip-raveUrl-job-${index}`}
      dataTestId='job-raveUrl-tooltip'
      placement='bottom-start'
      tooltipChildren={databaseId}
    >
      <Link href={raveUrl} dataTestId='job-raveUrl-link' targetBlank>{hostname}</Link>
    </Tooltip>
    : null
}

export default RaveUrlCell
